module.exports = __webpack_public_path__ + "img/icon-valor-liquido.b534611e.svg";